$(function () {
    $('.js-biological-autocomplete').autocomplete({
        serviceUrl: '/biologicals/search',
        groupBy: 'category',
        minChars: 0,
        dataType: 'json',
        showNoSuggestionNotice: true,
        noSuggestionNotice: function () {
            $(this).trigger('keyup');
            return $('.js-biological-autocomplete').val() + " toevoegen";
        },
        onSelect: function (suggestion) {
            $('.js-category-default').attr('hidden', ! suggestion.data.used_for);
            $('.js-category-wrapper').attr('hidden', !! suggestion.data.used_for);
            $('.js-category-default .js-category').html(suggestion.data.used_for);
            $('.js-category-wrapper .js-category').val(suggestion.data.used_for);
        }
    }).on('keyup', function () {
        $('.autocomplete-no-suggestion').html($('.js-biological-autocomplete').val() + " toevoegen");
    });

    $('.js-edit-category').on('click', function () {
        $('.js-category-wrapper').attr('hidden', false);
        $('.js-category-wrapper .js-category').val('').focus();
        $('.js-category-default').attr('hidden', true);

        return false;
    });
});
